/**
 * Creates all the attributes needed for the Button Controls component
 */
/**
 * External dependencies
 */
import { createAllCombinationAttributes, createTypographyAttributes } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

/**
 * Internal dependencies
 */
import { omitAttributes, pickAttributes } from '../attributes'

const createButtonAttributes = ( attrNameTemplate, options = {} ) => {
	const {
		defaultText = __( 'Button Text', i18n ),
		defaultUrl = '#',
		defaultDesign = 'solid',
		defaultShape = '',
		defaultSize = '',
		defaultAnimation = 'none',
		defaultDelay = 'none',
		defaultIcon = '',
		isShadow = false,
		iconAfterText = false,
		isButtonicon = false,
		backgroundColor = 'primary',
		exclude = [],
		include = [],
	} = options

	return pickAttributes( omitAttributes( {
		...createTypographyAttributes( attrNameTemplate ),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultText,
			},
			[
				'Text',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultUrl,
			},
			[
				'Url',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultDesign,
			},
			[
				'Design',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultIcon,
			},
			[
				'Icon',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultSize,
			},
			[
				'Size',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultShape,
			},
			[
				'Shape',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'boolean',
				default: isShadow,
			},
			[
				'Shadow',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'boolean',
				default: isButtonicon,
			},
			[
				'Button Icon'
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'boolean',
				default: iconAfterText,
			},
			[
				'IconAfterText',
			]
		),

		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: backgroundColor,
			},
			[
				'BackgroundColor',
			]
		),
		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultAnimation,
			},
			[
				'Animation',
			]
		),

		...createAllCombinationAttributes(
			attrNameTemplate,
			{
				type: 'string',
				default: defaultDelay,
			},
			[
				'Delay',
			]
		),
	}, exclude, attrNameTemplate ), include, attrNameTemplate )
}

export default createButtonAttributes

export const createButtonAttributeNames = attrNameTemplate => Object.keys( createButtonAttributes( attrNameTemplate ) )
